import Container from '@wearesection/bandai-react-components/atoms/Container';
import {IVerticalScrollingThumbnailCard} from '@wearesection/bandai-react-components/organisms/VerticalScrollingThumbnailCard';
import React, {useMemo} from 'react';
import RenderNextImage from '../../atoms/render-next-image';
import {PLACEHOLDER_IMG} from '~/constants';
import {GetRouter} from '~/utils';
import {Box} from '@mui/material';
import dynamic from 'next/dynamic';

const VerticalScrollingThumbnailCard = dynamic(
  () => import('@wearesection/bandai-react-components/organisms/VerticalScrollingThumbnailCard')
);

type IVerticalScrollingThumbnailCardExt = IVerticalScrollingThumbnailCard & {
  locale?: string;
  dataQueryTags?: string[];
  setDataFilterSelected?: Function | null;
  dataQueryGame?: string;
};

const adapter = (data: IVerticalScrollingThumbnailCardExt) => {
  const IMG_ERROR = PLACEHOLDER_IMG;
  const {locale} = GetRouter();
  const handleRenderNextImage = (
    src: string,
    width?: string | number,
    height?: string | number,
    alt?: string
  ) => {
    return <RenderNextImage src={src || IMG_ERROR} width={width} height={height} alt={alt} />;
  };
  return {
    title: data?.title ?? '',
    handlerScroll: data.handlerScroll,
    locale: locale,
    listThumbnail: [],
    dataQueryTags: data.dataQueryTags ?? [],
    setDataFilterSelected: data.setDataFilterSelected ?? null,
    dataQueryGame: data.dataQueryGame ?? '',
    nextImage: handleRenderNextImage,
  };
};

const PADDING_COMPONENT: any = {
  '/news': {
    paddingTop: '0px',
    paddingBottom: {
      xs: '72px',
      lg: '80px',
    },
  },
};

const VerticalScrollingThumbnailCardOrganisms: React.FC<IVerticalScrollingThumbnailCardExt> = (
  props: any
) => {
  const {locale, pathname} = GetRouter();
  const VerticalScrollingThumbnailCardOrganismsProps = useMemo(() => adapter(props), [props]);
  return (
    <Box sx={PADDING_COMPONENT[pathname] ?? {}}>
      <Container>
        <VerticalScrollingThumbnailCard
          {...VerticalScrollingThumbnailCardOrganismsProps}
          locale={locale ?? ''}
        />
      </Container>
    </Box>
  );
};

export default VerticalScrollingThumbnailCardOrganisms;
